module.exports = "/_next/static/images/google-94b3a9670871302487a07f1fb4e9ff17.png";